import styled from "@emotion/styled";

export const InputContainer = styled.div<{ hasTranslations?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ${({ hasTranslations }) =>
    hasTranslations &&
    `div.MuiFormControl-root {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }`}
`;
